import { PageId } from 'constants/pages'

export const enum PageIdStylioSnrsIo {
  AGE_SNRS_IO = PageId.AGE_SNRS_IO,
  URGE_SNRS_IO = PageId.URGE_SNRS_IO,
  HAIR_COLOR_SNRS_IO = PageId.HAIR_COLOR_SNRS_IO,
  EYES_COLOR_SNRS_IO = PageId.EYES_COLOR_SNRS_IO,
  JEWELRY_SNRS_IO = PageId.JEWELRY_SNRS_IO,
  BODY_SHAPE_SNRS_IO = PageId.BODY_SHAPE_SNRS_IO,
  STYLIO_TO_HELP_SNRS_IO = PageId.STYLIO_TO_HELP_SNRS_IO,
  TALL_SNRS_IO = PageId.TALL_SNRS_IO,
  WEIGHT_SNRS_IO = PageId.WEIGHT_SNRS_IO,
  URGE_2_SNRS_IO = PageId.URGE_2_SNRS_IO,
  SHOPPING_SNRS_IO = PageId.SHOPPING_SNRS_IO,
  STYLE_MOST_MATTERS_SNRS_IO = PageId.STYLE_MOST_MATTERS_SNRS_IO,
  FAVORITE_COLORS_SNRS_IO = PageId.FAVORITE_COLORS_SNRS_IO,
  LIKE_OR_DISLIKE_SNRS_IO = PageId.LIKE_OR_DISLIKE_SNRS_IO,
  LIKE_OR_DISLIKE_11_SNRS_IO = PageId.LIKE_OR_DISLIKE_11_SNRS_IO,
  LIKE_OR_DISLIKE_12_SNRS_IO = PageId.LIKE_OR_DISLIKE_12_SNRS_IO,
  LIKE_OR_DISLIKE_13_SNRS_IO = PageId.LIKE_OR_DISLIKE_13_SNRS_IO,
  LIKE_OR_DISLIKE_14_SNRS_IO = PageId.LIKE_OR_DISLIKE_14_SNRS_IO,
  LIKE_OR_DISLIKE_15_SNRS_IO = PageId.LIKE_OR_DISLIKE_15_SNRS_IO,
  LIKE_OR_DISLIKE_16_SNRS_IO = PageId.LIKE_OR_DISLIKE_16_SNRS_IO,
  LIKE_OR_DISLIKE_17_SNRS_IO = PageId.LIKE_OR_DISLIKE_17_SNRS_IO,
  STYLES_FEEL_LIKE_YOU_SNRS_IO = PageId.STYLES_FEEL_LIKE_YOU_SNRS_IO,
  URGE_4_SNRS_IO = PageId.URGE_4_SNRS_IO,
  BRAND_SNRS_IO = PageId.BRAND_SNRS_IO,
  FIND_NEW_CLOTHES_SNRS_IO = PageId.FIND_NEW_CLOTHES_SNRS_IO,
  NOTHING_TO_WEAR_SNRS_IO = PageId.NOTHING_TO_WEAR_SNRS_IO,
  OLD_CLOTHES_SNRS_IO = PageId.OLD_CLOTHES_SNRS_IO,
  COMBINE_CLOTHES_SNRS_IO = PageId.COMBINE_CLOTHES_SNRS_IO,
  OUTFIT_LOOK_SNRS_IO = PageId.OUTFIT_LOOK_SNRS_IO,
  OPTIMIZE_BUDGET_SNRS_IO = PageId.OPTIMIZE_BUDGET_SNRS_IO,
  EVERYDAY_LIFESTYLE_SNRS_IO = PageId.EVERYDAY_LIFESTYLE_SNRS_IO,
  CLIMAT_SNRS_IO = PageId.CLIMAT_SNRS_IO,
  URGE_3_SNRS_IO = PageId.URGE_3_SNRS_IO,
  PREPARE_FLOW_SNRS_IO = PageId.PREPARE_FLOW_SNRS_IO,
  EMAIL_SNRS_IO = PageId.EMAIL_SNRS_IO,
  EMAIL_CONSENT_SNRS_IO = PageId.EMAIL_CONSENT_SNRS_IO,
  SUBSCRIPTIONS_SNRS_IO = PageId.SUBSCRIPTIONS_SNRS_IO,
  CANCEL_OFFER_SNRS_IO = PageId.CANCEL_OFFER_SNRS_IO,
  AI_STYLIST_UPSELL_SNRS_IO = PageId.AI_STYLIST_UPSELL_SNRS_IO,
  SUB_UPSELL_SNRS_IO = PageId.SUB_UPSELL_SNRS_IO,
  UPSELL_SNRS_IO = PageId.UPSELL_SNRS_IO,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_SNRS_IO = PageId.DOWNLOAD_SNRS_IO,
}
